import { HEADER_OFFSET } from "config/config";
import { useEffect } from "react";

export const PAGE_TITLE_ID = "page-title";

// Opens a document page with its title at the top of the viewport, just under
// the fixed header. ScrollToContent only brings the top of the content up,
// which still leaves the back link, any banners and the content padding above
// the title — on a short viewport (an embedded webview, where the native shell
// takes part of the screen) that is enough to push the scan and upload buttons
// below the fold, and the page looks like it has nothing to act on.
const useScrollToPageTitle = (isEnabled = true) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    // a frame later than ScrollToContent's route-change scroll, so this is the
    // one that lands
    const frame = window.requestAnimationFrame(() => {
      const title = document.getElementById(PAGE_TITLE_ID);

      if (!title) {
        return;
      }

      window.scrollTo({
        top: window.scrollY + title.getBoundingClientRect().top - HEADER_OFFSET,
        behavior: "smooth",
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [isEnabled]);
};

export default useScrollToPageTitle;
